import React from "react";
import { Summary } from "store/reducers";

import { Duration } from "../timesheet_viewer/table_components/duration";

type Props = {
  summary: Summary;
};

export function OrdinaryHoursSummary({ summary }: Props) {
  return (
    <div>
      {summary.worked.ordinary > 0 && <Duration seconds={summary.worked.ordinary} />}
      {summary.worked.vocational > 0 && (
        <div>
          Vocational: <Duration seconds={summary.worked.vocational} />
        </div>
      )}
    </div>
  );
}

export function WeekendHoursSummary({ summary }: Props) {
  return (
    <div>
      {summary.worked.saturday_first_two > 0 && (
        <div>
          Sat first 2: <Duration seconds={summary.worked.saturday_first_two} />
        </div>
      )}
      {summary.worked.saturday_after_two > 0 && (
        <div>
          Sat after 2: <Duration seconds={summary.worked.saturday_after_two} />
        </div>
      )}
      {summary.worked.sunday > 0 && (
        <div>
          Sun: <Duration seconds={summary.worked.sunday} />
        </div>
      )}
    </div>
  );
}
